import { PARTIAL_SUCCESS, SUCCESS } from '../constants'

const isMenuScrapedSuccessfully = status =>
  status === SUCCESS || status === PARTIAL_SUCCESS

export default isMenuScrapedSuccessfully
